import keyEvent from './keyEvent'
import track from './track'
import svga from './svga'
import clickoutside from './clickoutside'
import Int from './int'
import expandInput from './expandInput'
import inputNumber from './inputNumber';

const directives = {
    keyEvent,track,svga,clickoutside,Int,expandInput, inputNumber
}

export default {
    install(Vue){
        Object.keys(directives).forEach(key =>{
            // console.log("🚀 ~ key", key)
            Vue.directive(key,directives[key])
        })
    }
}



// WEBPACK FOOTER //
// ./src/common/directives/index.js